import React from "react";
import { useTranslation } from 'react-i18next';
import UserProfileView from '../../../../components/user/UserProfileView';
import UserPageLayout from '../../../../components/user/UserPageLayout';

const UserProfile = () => {
    const { t } = useTranslation();

    return (
        <UserPageLayout title={t('profile.title')} >
            <UserProfileView />
        </UserPageLayout>
    )
}

export default UserProfile;
